import React, { useState, useEffect } from 'react';
import { FiCalendar, FiX } from 'react-icons/fi';
import { format, parseISO } from 'date-fns';
import { useSearch } from '../../contexts/SearchContext';
import { getVideoDateRange } from '../../services/searchService';
import './DateRangePicker.css';

/// DateRangePickerコンポーネントのProps
interface DateRangePickerProps {
  isModal?: boolean;
  onClose?: () => void;
}

/// 日付範囲選択コンポーネント
const DateRangePicker: React.FC<DateRangePickerProps> = ({
  isModal = false,
  onClose
}) => {
  const { state, dispatch } = useSearch();
  const [startDate, setStartDate] = useState<string>(
    state.dateRange.startDate ? format(state.dateRange.startDate, 'yyyy-MM-dd') : ''
  );
  const [endDate, setEndDate] = useState<string>(
    state.dateRange.endDate ? format(state.dateRange.endDate, 'yyyy-MM-dd') : ''
  );
  const [minDate, setMinDate] = useState<string>('');
  const [maxDate, setMaxDate] = useState<string>('');

  /// 動画データの日付範囲を取得
  useEffect(() => {
    const range = getVideoDateRange();
    if (range) {
      setMinDate(format(range.minDate, 'yyyy-MM-dd'));
      setMaxDate(format(range.maxDate, 'yyyy-MM-dd'));
    }
  }, []);

  /// 日付範囲をクリア
  const clearRange = () => {
    setStartDate('');
    setEndDate('');
  };

  /// 選択を適用
  const applySelection = () => {
    // タイムゾーンの問題を避けるため、ISO文字列からDateを生成
    const start = startDate ? parseISO(startDate) : null;
    const end = endDate ? parseISO(endDate) : null;
    
    dispatch({ 
      type: 'SET_DATE_RANGE', 
      payload: {
        startDate: start,
        endDate: end
      }
    });
    
    if (onClose) {
      onClose();
    }
  };

  const containerClass = `date-range-picker ${isModal ? 'date-range-picker--modal' : ''}`;

  return (
    <div className={containerClass}>
      {isModal && (
        <div className="date-range-picker__header">
          <h3 className="date-range-picker__title">
            {FiCalendar({ className: "date-range-picker__icon" })}
            期間を選択
          </h3>
          <button 
            className="date-range-picker__close"
            onClick={onClose}
            aria-label="閉じる"
          >
            {FiX({})}
          </button>
        </div>
      )}

      <div className="date-range-picker__inputs">
        <div className="date-range-picker__input-group">
          <label htmlFor="start-date" className="date-range-picker__label">
            開始日
          </label>
          <input
            id="start-date"
            type="date"
            className="date-range-picker__input"
            value={startDate}
            min={minDate}
            max={maxDate}
            onChange={(e) => setStartDate(e.target.value)}
          />
        </div>
        
        <div className="date-range-picker__input-group">
          <label htmlFor="end-date" className="date-range-picker__label">
            終了日
          </label>
          <input
            id="end-date"
            type="date"
            className="date-range-picker__input"
            value={endDate}
            min={startDate || minDate}
            max={maxDate}
            onChange={(e) => setEndDate(e.target.value)}
          />
        </div>
      </div>

      {/* <div className="date-range-picker__info">
        <p className="date-range-picker__range-info">
          {minDate && maxDate && (
            <>
              選択可能範囲: {format(parseISO(minDate), 'yyyy年MM月dd日', { locale: ja })} 〜 {format(parseISO(maxDate), 'yyyy年MM月dd日', { locale: ja })}
            </>
          )}
        </p>
      </div> */}

      <div className="date-range-picker__actions">
        <button 
          className="date-range-picker__clear-btn"
          onClick={clearRange}
        >
          クリア
        </button>
        <button 
          className="date-range-picker__apply-btn"
          onClick={applySelection}
        >
          適用
        </button>
      </div>
    </div>
  );
};

export default DateRangePicker; 